'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const delay=require('pulsar-utils/dist-es6/async/delay');
const moment=require('pulsar-utils/dist-es6/time/moment');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const WaypointTypes=require('../../../../../dist-es6/client/domain/waypointTypes');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');let

ScenarioSetupModalController=(_dec=






























HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class ScenarioSetupModalController extends BaseController{static get $inject(){return['$modalInstance','dateService','uiCommandFactory','personId','tripPlanningService','originAddress','uncaughtErrorHandler']}constructor($modalInstance,dateService,uiCommandFactory,personId,tripPlanningService,originAddress,uncaughtErrorHandler){super(uncaughtErrorHandler);this._$modalInstance=$modalInstance;this._tripPlanningService=tripPlanningService;this._personId=personId;let currentTime=dateService.now();this._originAddress=originAddress;this._originTime=currentTime;this._originTime.setSeconds(0);this._originTime.setMilliseconds(0);this._originWaypointType=WaypointTypes.unselected;this._destinationAddress=null;this._destinationTime=null;this._destinationWaypointType=WaypointTypes.unselected;this._submissionErrors=[];this._calculateRouteCommand=uiCommandFactory.makeForModal($modalInstance,this._calculate.bind(this))}get calculateRouteCommand(){return this._calculateRouteCommand}
async _calculate(){
let planInputs=[{
address:this.originAddress,
displayTime:this.originTime,
waypointType:this.originWaypointType},
{
address:this.destinationAddress,
displayTime:this.destinationTime,
waypointType:this.destinationWaypointType}];

let result=await this._tripPlanningService.plan(this._personId,planInputs);

if(_.exists(result.errors)){
this._submissionErrors=result.errors;
return ModalSubmissionResult.KeepOpen;
}


result.originalInputs=planInputs;
return ModalSubmissionResult.Close(result);
}

onCancel(){
this._$modalInstance.dismiss();
}

get submissionErrors(){
return this._submissionErrors;
}

get waypointTypes(){
return WaypointTypes.all;
}

get destinationAddress(){
return this._destinationAddress;
}

set destinationAddress(newDestinationAddress){
this._destinationAddress=newDestinationAddress;
}

get destinationTime(){
return this._destinationTime;
}

set destinationTime(newDestinationTime){
this._destinationTime=newDestinationTime;
}

get destinationWaypointType(){
return this._destinationWaypointType;
}

set destinationWaypointType(newDestinationWaypointType){
this._destinationWaypointType=newDestinationWaypointType;
}

get originAddress(){
return this._originAddress;
}

set originAddress(newOriginAddress){
this._originAddress=newOriginAddress;
}

get originTime(){
return this._originTime;
}

set originTime(newOriginTime){
this._originTime=newOriginTime;
}

get originWaypointType(){
return this._originWaypointType;
}

set originWaypointType(newOriginWaypointType){
this._originWaypointType=newOriginWaypointType;
}},(_applyDecoratedDescriptor(_class.prototype,'_calculate',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_calculate'),_class.prototype)),_class));


module.exports=ScenarioSetupModalController;
//# sourceMappingURL=scenarioSetupModalController.js.map
